export default __webpack_public_path__ + "static/media/tick.6acb3b8c.png";